import { render, staticRenderFns } from "./MyTasks.vue?vue&type=template&id=f37f6bc2&scoped=true"
import script from "./MyTasks.vue?vue&type=script&lang=js"
export * from "./MyTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37f6bc2",
  null
  
)

export default component.exports